import { gql } from '@apollo/client';

export const IS_FRENCH_AND_DOM_TOM_REGION = gql`
  query IS_FRENCH_AND_DOM_TOM_REGION($country: String!) {
    isFrenchAndDomTomRegion(country: $country)
  }
`;
